import { createClient } from 'contentful';

let cachedClient;

export function getContentfulClient() {
  if (cachedClient !== undefined) {
    return cachedClient;
  }
  const space = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
  const accessToken =
    process.env.REACT_APP_CONTENTFUL_CDA_TOKEN ||
    process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;
  const environment = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master';

  if (!space || !accessToken) {
    cachedClient = null;
    return null;
  }

  cachedClient = createClient({
    space,
    accessToken,
    environment,
  });
  return cachedClient;
}

export function isContentfulConfigured() {
  return Boolean(
    process.env.REACT_APP_CONTENTFUL_SPACE_ID &&
      (process.env.REACT_APP_CONTENTFUL_CDA_TOKEN ||
        process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN)
  );
}
